/**********************
 *
 */

import React, { useState } from "react";
import { sendGET } from "../utils/comm.js";

const buildTable = (ary) => {
  if (!ary || !ary.length) return <div>No data...</div>;
  return ary.map((line) => {
    let cellStyle = {
      display: "table-cell",
      marginRight: "1em",
      paddingRight: "1em",
    };
    let blank = "";
    if (line.event === "Start Screen") {
      // Put in a blank row to separate
      blank = <div style={{ display: "table-row" }}>-----</div>;
    }
    return (
      <>
        {blank}
        <div
          style={{
            display: "table-row",
            whiteSpace: "nowrap",
            lineHeight: "1.7em",
            fontSize: "1.6em",
          }}
        >
          <div style={cellStyle}>{line.dateLocale}</div>
          <div style={cellStyle}>{line.event}</div>
          <div style={cellStyle}>{line.userEmail}</div>
          <div style={cellStyle}>{line.userAgent} </div>
        </div>
      </>
    );
  });
};

export default (props) => {
  const [fromDate, setFromDate] = useState(3);
  const [code, setCode] = useState("");
  let [table, setTable] = useState(<div></div>);

  return (
    <div
      style={{
        color: "black",
        backgroundColor: "rgb(244,245,250)",
        borderRadius: "30px",
        margin: "auto auto",
        marginTop: "10px",
        padding: "1em",
        // width: "90%",
        display: "inline-block",
        fontSize: "1em",
      }}
    >
      <h2>User Progress Tracker</h2>
      <label>Code:&nbsp;</label>
      <input
        type="text"
        value={code}
        onChange={(e) => {
          e.preventDefault();
          setCode(e.target.value);
        }}
      />
      <label>&nbsp;From how many days past:&nbsp;</label>
      <input
        type="text"
        value={fromDate}
        size={4}
        onChange={(e) => {
          e.preventDefault();
          setFromDate(e.target.value);
        }}
      />
      &nbsp;
      <button
        onClick={async (e) => {
          e.preventDefault();
          e.stopPropagation();

          console.log(
            "Cur getTime:",
            new Date().getTime(),
            "fromDate:",
            fromDate
          );
          console.log(
            "after subtraction:",
            new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * fromDate)
          );
          let ddd = new Date(
            new Date().getTime() - 24 * 60 * 60 * 1000 * fromDate
          );
          let results = await sendGET(`/progress/${code}/${ddd.getTime()}`);
          console.log("results:", results);
          setTable(
            <div
              style={{
                display: "table",
                fontSize: "0.5em",
                marginTop: "10px",
              }}
            >
              {buildTable(results)}
            </div>
          );
        }}
      >
        {" "}
        GO
      </button>
      {table}
    </div>
  );
};
